"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Modal;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ModalModule = _interopRequireDefault(require("./Modal.module.css"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @param {boolean} show
 * @param {func} close
 * @param {string} closeIcon
 * @param {string} title
 * @param {node} children
 * @returns {ReactElement}
 */
function Modal(_ref) {
  var show = _ref.show,
      close = _ref.close,
      closeIcon = _ref.closeIcon,
      title = _ref.title,
      children = _ref.children;

  var modalRef = _react["default"].useRef();

  var keyDownHandler = function keyDownHandler(e) {
    if (e.key !== "Tab") return;
    var focusableModalElements = modalRef.current.querySelectorAll("a[href], button:not([disabled]), textarea, input, select");
    var firstElement = focusableModalElements[0];
    var lastElement = focusableModalElements[focusableModalElements.length - 1];

    if (!e.shiftKey && document.activeElement === lastElement) {
      firstElement.focus();
      return e.preventDefault();
    }

    if (e.shiftKey && document.activeElement === firstElement) {
      lastElement.focus();
      e.preventDefault();
    }
  };

  var keyListenersMap = new Map([[27, close], [9, keyDownHandler]]);

  _react["default"].useEffect(function () {
    function keyListener(e) {
      var listener = keyListenersMap.get(e.keyCode);
      return listener && listener(e);
    }

    document.addEventListener("keydown", keyListener);
    return function () {
      return document.removeEventListener("keydown", keyListener);
    };
  });

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "".concat(_ModalModule["default"].overlay, " ").concat(show ? _ModalModule["default"].show : "", " "),
    onClick: function onClick() {
      return close();
    },
    role: "dialog",
    "aria-modal": "true",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _ModalModule["default"].content,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      ref: modalRef,
      children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
        className: _ModalModule["default"].title,
        children: title
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        className: _ModalModule["default"].close,
        onClick: function onClick() {
          return close();
        },
        children: closeIcon ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          className: _ModalModule["default"].closeContent,
          src: closeIcon,
          alt: "close"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _ModalModule["default"].closeContent,
          children: "\u274C"
        })
      }), children ? children : null]
    })
  });
}

Modal.propTypes = {
  show: _propTypes["default"].bool.isRequired,
  close: _propTypes["default"].func.isRequired,
  closeIcon: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node
};